<template>
  <b-row>
    <!-- Row Loop -->
    <!-- <b-card
      title="ข้อมูลผู้ร้องทุกข์ / ผู้ดำเนินการ"
      class="w-100">

      </b-card> -->

    <div v-if="showChannel === true" class="container mb-2">
      <b-form-group label="ช่องทางการร้องทุกข์" label-for="selectedChannel">
        <b-form-select
          :value="selectedChannel"
          @input="onChanged"
          :options="channels"
          class="mt-1 pl-1"
        />
      </b-form-group>
    </div>

    <div v-if="ComponentName === 'ProvincialComplaint'" class="container mb-2">
      <b-form-group label="จังหวัด" label-for="province">
        <b-form-select
          :value="province"
          @input="onProvinceChanged"
          :options="provinces"
          class="mt-1 pl-1"
        />
      </b-form-group>
    </div>

    <div v-if="ComponentName === 'ProvincialComplaint'" class="container mb-2">
      <b-form-group label="วันที่ร้องทุกข์" label-for="dateComplaint">
        <b-form-datepicker
          id="dateSearch"
          v-model="dateComplaint"
          class="mb-2"
          locale="th"
          :hide-header="false"
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }"
          :max="max"
          today-button
          close-button
          @input="onDateComplaintChange"
          no-flip
        ></b-form-datepicker>
      </b-form-group>
    </div>

    <b-col cols="12" class="mb-2">
      <h3 v-if="isAttorneyCompliant === false" class="mb-0">
        ข้อมูลผู้ร้องทุกข์
        <small class="text-danger text-small">
          **โปรดระบุข้อมูลอย่างน้อย 1 รายการ</small
        >
      </h3>
      <h3 class="mb-0" v-else>
        ผู้ดำเนินการ
        <small class="text-danger text-small">
          **โปรดระบุข้อมูลอย่างน้อย 1 รายการ และมากสุด 1 รายการ</small
        >
      </h3>
    </b-col>

    <div
      v-for="(item, index) in personals"
      :id="item.userId"
      :key="'personal' + index"
      class="container"
    >
      <b-list-group flush>
        <PersonDataDigital
          :AllowDelete="true"
          :IsReadOnly="false"
          :IsDeleteAble="true"
          :person="item"
          @handle-edit-personal="personalModalEditClicked(item.userId)"
          @handle-deleted-personal="personalDeleteClicked(item.userId)"
        />
      </b-list-group>
    </div>
    <div
      class="container mb-3"
      v-if="
        (isAttorneyCompliant === true && personals.length < 1) ||
          (isAttorneyCompliant === false && personals.length < 1)
      "
    >
      <b-button variant="primary" @click="personalModalAddClicked">
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span>เพิ่มข้อมูล</span>
      </b-button>
    </div>

    <b-col
      v-if="personals.length > 0"
      cols="12"
      md="6"
      class="mb-2 d-flex justify-content-around"
    >
      <b-form-radio
        v-model="attorneyRadio"
        :value="false"
        @change="onIsAttorneyComplaintChange(false)"
      >
        ร้องทุกข์ด้วยตนเอง
      </b-form-radio>
      <b-form-radio
        v-model="attorneyRadio"
        :value="true"
        @change="onIsAttorneyComplaintChange(true)"
      >
        ร้องแทนผู้อื่น
      </b-form-radio>
    </b-col>

    <b-col cols="12" class="mb-2" v-if="isAttorneyCompliant === true">
      <h3 class="mb-0">
        ผู้มอบอำนาจ
      </h3>
    </b-col>

    <div
      v-for="(item, index) in attorneys"
      :id="item.userId"
      :key="'attorney' + index"
      class="container"
    >
      <b-list-group flush v-if="isAttorneyCompliant === true">
        <PersonDataDigital
          :AllowDelete="true"
          :IsReadOnly="false"
          :IsDeleteAble="true"
          :person="item"
          @handle-edit-personal="personalModalEditClicked(item.userId)"
          @handle-deleted-personal="personalDeleteClicked(item.userId)"
        />
      </b-list-group>
    </div>
    <div class="container" v-if="isAttorneyCompliant === true">
      <b-button variant="primary" @click="attorneyModalAddClicked">
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span>เพิ่มข้อมูล</span>
      </b-button>
    </div>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormRadio,
  BForm,
  BButton,
  BCard,
  BListGroup,
  BFormSelect,
  BFormDatepicker,
} from "bootstrap-vue";
// import { required, email } from '@validations'
import Personal from "./Personal.vue";
import PersonDataDigital from "../../components/PersonDataDigital.vue";
import appsettings from "@/store/app-settings/index.js";
import * as userData from "@/auth/localStorageUtils.js";

import * as masterStore from "@/store/api/master/index.js";
import { integer } from "vee-validate/dist/rules";

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BButton,
    BCard,
    BListGroup,
    BFormSelect,
    BFormGroup,
    BFormRadio,
    Personal,
    PersonDataDigital,
    BFormDatepicker,
  },
  props: {
    personals: {
      type: Array,
      default() {
        return [];
      },
    },
    attorneys: {
      type: Array,
      default() {
        return [];
      },
    },
    showChannel: {
      type: Boolean,
      default: false,
    },
    selectedChannel: {
      type: Number,
      default: 65,
    },
    isAttorneyCompliant: false,
    ComponentName: "",
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);
    return {
      channels: [],
      provinces: [],
      province: null,
      dateComplaint: new Date(),
      max: maxDate,
    };
  },
  setup(props) {
    console.log("props companyDetail", props);
    return {
      attorneyRadio: props.isAttorneyCompliant,
    };
  },
  created() {
    // `this` points to the vm instance
    console.log(`a is: ${this.a}`);

    this.getChannels();
    this.getProvinces();
  },
  methods: {
    getProvinces() {
      const _this = this;
      if (
        appsettings.complaintRoleId.province.toLowerCase() ===
        userData.selectedRole().toLowerCase()
      ) {
        masterStore.getProvince().then((response) => {
          console.log("response masterByType", response);

          const filterProvinces = response.data.data.filter((value) => {
            return value.value === userData.province();
          });

          _this.provinces = filterProvinces;
          _this.province = _this.provinces[0].value;
        });
      } else if (
        appsettings.complaintRoleId.area.toLowerCase() ===
        userData.selectedRole().toLowerCase()
      ) {
        masterStore.getProvinceByArea(userData.area()).then((response) => {
          console.log("response masterByType", response);

          _this.provinces = response.data.data;
          _this.province = _this.provinces[0].value;
        });
      } else {
        masterStore.getProvince().then((response) => {
          console.log("response masterByType", response);

          _this.provinces = response.data.data;
          _this.province = _this.provinces[0].value;
        });
      }
    },
    getCurrentDate() {
      const _this = this;
      const dateNow = new Date();
      return dateNow.toLocaleDateString("en-US");
    },
    onChanged(e) {
      console.log("e", e);
      this.$emit("handle-selectedChannel", e);
    },
    onProvinceChanged(e) {
      console.log("e", e);
      this.$emit("handle-selectedProvince", e);
    },
    onIsAttorneyComplaintChange(value) {
      this.$emit("handle-isAttorneyComplaintChange", value);
    },
    onDateComplaintChange(value) {
      // console.log("dateComplaint", value)
      this.$emit("handle-selectDateComplaint", value);
    },
    getChannels() {
      masterStore.getMasterByType(1).then((response) => {
        console.log("response masterByType", response);

        const masters = response.data.data.map(function(obj) {
          return { value: obj.masterId, text: obj.description };
        });

        // console.log("masters", masters);
        // this.channels = masters;

        if (this.$route.query.parentComponent === "screening") {
          console.log("@masters route", this.$route.query);
          const masterScreening = masters.filter(
            (item) =>
              item.value === 31 ||
              item.value === 40 ||
              item.value === 60 ||
              item.value === 65 ||
              item.value === 67 ||
              item.value === 68 ||
              item.value === 71 ||
              item.value === 72
          );
          this.channels = masterScreening;
          this.selectedChannel = 60; // ศูนย์รับเรื่องราวร้องทุกข์
        } else {
          this.channels = masters;
        }
      });
    },
    personalModalAddClicked() {
      this.$emit("personal-modal-clicked", "personal", -1);
    },
    personalModalEditClicked(id) {
      this.$emit("personal-modal-clicked", "personal", id);
    },
    personalDeleteClicked(id) {
      this.$emit("personal-deleted", "personal", id);
    },
    attorneyModalAddClicked() {
      this.$emit("personal-modal-clicked", "attorney", -1);
    },
    attorneyModalEditClicked(id) {
      this.$emit("personal-modal-clicked", "attorney", id);
    },
    attorneyDeleteClicked(id) {
      this.$emit("personal-deleted", "attorney", id);
    },
  },
};
</script>
